const AppConfig = {
  DEBUG: process.env.REACT_APP_DEBUG_MODE,
  apiURL: process.env.REACT_APP_API_URL,
  NODE_ENV: process.env.NODE_ENV
}

export default AppConfig



// WEBPACK FOOTER //
// ./src/Config/AppConfig.js